import axios from 'axios';
import { API_URL } from '../config';
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}

export const listOrganizationalUnits = async (
  token: string, 
  flat: boolean = false, 
  currentId: number | null, 
  permission: string | null,
) => {
  const params: Record<string, any> = {};
  if(flat) params['flat'] = 1;
  if(currentId) params['ou'] = currentId;
  
  const response = await axios.get(`${API_URL}/ou/?${new URLSearchParams(params).toString()}`,
    {
      headers: {
        'Authorization': `${token}`,
      },
      permission,
    } as CustomAxiosRequestConfig);
  // Return the search results
  return response.data;
}
  
  export const getOrganizationalUnit = async (token: string, id: string|number) => {
    const response = await axios.get(`${API_URL}/ou/${id}`,
      {
        headers: {
          'Authorization': `${token}`,
        }
      });
    // Return the search results
    return response.data;
  }
  
  
  /* 
  body example:
  {name: 'test a', parent: 1, employees: [2], managers: [4]} 
  */
  export const updateOrganizationalUnit = async (token: string, id: string | number, body: any) => {
    const response = await axios.put(`${API_URL}/ou/${id}`, body,
      {
        headers: {
          'Authorization': `${token}`,
        }
      });
    // Return the search results
    return response.data;
  }
  
  /* 
  body example:
  {name: 'test a', parent: 1, employees: [2], managers: [4]} 
  */
  export const createOrganizationalUnit = async (token: string, body: any) => {
    const response = await axios.post(`${API_URL}/ou/`, body,
      {
        headers: {
          'Authorization': `${token}`,
        }
      });
    // Return the search results
    return response.data;
  }
  
  export const deleteOrganizationalUnit = async (token: string, ou_id: string | number) => {
    const response = await axios.delete(`${API_URL}/ou/${ou_id}`,
      {
        headers: {
          'Authorization': `${token}`,
        }
      });
    // Return the search results
    return response.data;
  }
  
  
  export const addHandlerToOrganizationalUnit = async (token: string, ou_id: string | number, employee_id: string | number) => {
    const response = await axios.post(`${API_URL}/ou/${ou_id}/handler`, [employee_id],
      {
        headers: {
          'Authorization': `${token}`,
        }
      });
    // Return the search results
    return response.data;
  }
  
  export const addMemberToOrganizationalUnit = async (token: string, ou_id: string | number, employee_id: string | number) => {
    const response = await axios.post(`${API_URL}/ou/${ou_id}/member`, [employee_id],
      {
        headers: {
          'Authorization': `${token}`,
        }
      });
    // Return the search results
    return response.data;
  }
  
  export const removeEmployeeFromOrganizationalUnit = async (token: string, ou_id: string | number, employee_id: string | number) => {
    const response = await axios.delete(`${API_URL}/ou/${ou_id}/employee/${employee_id}`,
      {
        headers: {
          'Authorization': `${token}`,
        }
      });
    
      return response.data;
  }
  
  export const listEmployeesFromOrganizationalUnit = async (token: string, ou_id: string | number, query: string = '', role: string = '', page: number = 1, pageSize: number = 5) => {
    const params: Record<string, string | number> = {
      q: query,
      page,
      page_size: pageSize,
    };
  
    if (role) {
      params[role] = role;
    }
  
    const response = await axios.get(`${API_URL}/ou/${ou_id}/employee/`, {
      headers: {
        'Authorization': `${token}`,
      },
      params,
    });
  
    return response.data;
  };

  export const getEmployeeRoleAndUnit = async (token: string, employeeId: number) => {
  const response = await axios.get(`${API_URL}/dipendenti/${employeeId}/ous/`, {
    headers: {
      'Authorization': token,
    },
    params: {
      id: employeeId,
    }
  });
  return response.data;
}
